export default "__VITE_ASSET__ZllknAoW__"